export default function instantiationPromise() {
  let _resolve = null;
  let _reject = null;
  let promise = new Promise((resolve, reject) => {
    _resolve = resolve;
    _reject = reject;
  })
  return {
    promise,
    resolve: _resolve,
    reject: _reject
  }
}


// WEBPACK FOOTER //
// ./src/library/promiseTool.js